// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo {
  width: 138px;
  height: 49px;
  margin: 7px 29px 24px 12;
  float: left;
}

.header-menu {
  line-height: 64px;
}

.sider-menu {
  height: 100%;
  border-right: 0;
}

.hide-menu:hover {
  position: absolute;
  z-index: 9999;
}

nz-breadcrumb {
  margin: 16px 0;
}

nz-content {
  background: #f8f8fb;
  padding: 24px;
  min-height: 280px;
  padding-bottom: 70px;
}

.notification-icon {
  font-size: 20px !important;
}

nz-sider {
  box-shadow: 5px 0 15px -2px #d6d6d6;
  position: relative;
}

nz-breadcrumb {
  margin: 16px 0;
  padding: 0 24px;
}

::ng-deep .ant-breadcrumb-link a {
  color: #ff5757;
}

.chatWithSpoolify {
  right: 0;
  top: 10px;
  z-index: 99;
  display: flex;
  justify-content: flex-end;
  padding-right: 24px;
  padding-top: 5px;
  padding-bottom: 10px;
}
.chatWithSpoolify i {
  font-size: 20px;
  cursor: pointer;
  color: #ff5757;
  background: #fff;
  padding: 3px;
  border-radius: 20px;
  box-shadow: 0px 0px 5px 5px #a59d9d;
  margin-right: 10px;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
}

@keyframes shake-animation {
  0% {
    transform: translate(0, 0);
  }
  1.78571% {
    transform: translate(5px, 0);
  }
  3.57143% {
    transform: translate(0, 0);
  }
  5.35714% {
    transform: translate(5px, 0);
  }
  7.14286% {
    transform: translate(0, 0);
  }
  8.92857% {
    transform: translate(5px, 0);
  }
  10.71429% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(0, 0);
  }
}
.ant-back-top {
  right: 150px;
}

ant-back-top-rtl {
  right: unset;
  left: 150px;
}

.floating-chat-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.floating-chat-container .chat-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #ff4d4f;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #fff;
  position: relative;
  box-shadow: 0 0 15px rgba(255, 77, 79, 0.5);
}
.floating-chat-container .chat-icon::before, .floating-chat-container .chat-icon::after {
  content: "";
  position: absolute;
  inset: -3px;
  border-radius: 50%;
  border: 2px solid #ff4d4f;
  filter: drop-shadow(0 0 8px rgba(255, 77, 79, 0.8));
  animation: neonPulse 2s ease-in-out infinite;
}
.floating-chat-container .chat-icon::after {
  animation-delay: 1s;
  filter: drop-shadow(0 0 12px rgba(255, 77, 79, 0.6));
}
@keyframes neonPulse {
  0% {
    transform: scale(1);
    opacity: 0.8;
    filter: drop-shadow(0 0 8px rgba(255, 77, 79, 0.8));
  }
  50% {
    transform: scale(1.4);
    opacity: 0;
    filter: drop-shadow(0 0 15px rgb(255, 77, 79));
  }
  100% {
    transform: scale(1.6);
    opacity: 0;
    filter: drop-shadow(0 0 8px rgba(255, 77, 79, 0.8));
  }
}`, "",{"version":3,"sources":["webpack://./src/app/layouts/default/default.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,YAAA;EAEA,wBAAA;EACA,WAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAIA;EACE,YAAA;EACA,eAAA;AADF;;AAIA;EACE,kBAAA;EACA,aAAA;AADF;;AAQA;EACE,cAAA;AALF;;AAQA;EACE,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,oBAAA;AALF;;AAQA;EACE,0BAAA;AALF;;AAQA;EACE,mCAAA;EACA,kBAAA;AALF;;AAOA;EACE,cAAA;EACA,eAAA;AAJF;;AAQI;EACE,cAAA;AALN;;AAUA;EACE,QAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;AAPF;AAQE;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,mCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AANJ;;AAUA;EACE;IACE,0BAAA;EAPF;EASA;IACE,4BAAA;EAPF;EASA;IACE,0BAAA;EAPF;EASA;IACE,4BAAA;EAPF;EASA;IACE,0BAAA;EAPF;EASA;IACE,4BAAA;EAPF;EASA;IACE,0BAAA;EAPF;EASA;IACE,0BAAA;EAPF;AACF;AAUA;EACE,YAAA;AARF;;AAUA;EACE,YAAA;EACA,WAAA;AAPF;;AAUA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;AAPF;AAQE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,2CAAA;AANJ;AAQI;EAEE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,mDAAA;EACA,4CAAA;AAPN;AAUI;EACE,mBAAA;EACA,oDAAA;AARN;AAYE;EACE;IACE,mBAAA;IACA,YAAA;IACA,mDAAA;EAVJ;EAYE;IACE,qBAAA;IACA,UAAA;IACA,8CAAA;EAVJ;EAYE;IACE,qBAAA;IACA,UAAA;IACA,mDAAA;EAVJ;AACF","sourcesContent":[".logo {\n  width: 138px;\n  height: 49px;\n  // background: rgba(255, 255, 255, 0.2);\n  margin: 7px 29px 24px 12;\n  float: left;\n}\n\n.header-menu {\n  line-height: 64px;\n  // top:11px;\n}\n\n.sider-menu {\n  height: 100%;\n  border-right: 0;\n}\n\n.hide-menu:hover {\n  position: absolute;\n  z-index: 9999;\n}\n\n.inner-layout {\n  // padding: 5px 20px 20px;\n}\n\nnz-breadcrumb {\n  margin: 16px 0;\n}\n\nnz-content {\n  background: #f8f8fb;\n  padding: 24px;\n  min-height: 280px;\n  padding-bottom: 70px;\n}\n\n.notification-icon {\n  font-size: 20px !important;\n}\n\nnz-sider {\n  box-shadow: 5px 0 15px -2px #d6d6d6;\n  position: relative;\n}\nnz-breadcrumb {\n  margin: 16px 0;\n  padding: 0 24px;\n}\n::ng-deep {\n  .ant-breadcrumb-link {\n    a {\n      color: #ff5757;\n    }\n  }\n}\n\n.chatWithSpoolify {\n  right: 0;\n  top: 10px;\n  z-index: 99;\n  display: flex;\n  justify-content: flex-end;\n  padding-right: 24px;\n  padding-top: 5px;\n  padding-bottom: 10px;\n  i {\n    font-size: 20px;\n    cursor: pointer;\n    color: #ff5757;\n    background: #fff;\n    padding: 3px;\n    border-radius: 20px;\n    box-shadow: 0px 0px 5px 5px #a59d9d;\n    margin-right: 10px;\n    width: 30px;\n    height: 30px;\n    line-height: 30px;\n    text-align: center;\n  }\n}\n\n@keyframes shake-animation {\n  0% {\n    transform: translate(0, 0);\n  }\n  1.78571% {\n    transform: translate(5px, 0);\n  }\n  3.57143% {\n    transform: translate(0, 0);\n  }\n  5.35714% {\n    transform: translate(5px, 0);\n  }\n  7.14286% {\n    transform: translate(0, 0);\n  }\n  8.92857% {\n    transform: translate(5px, 0);\n  }\n  10.71429% {\n    transform: translate(0, 0);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n\n.ant-back-top {\n  right: 150px;\n}\nant-back-top-rtl {\n  right: unset;\n  left: 150px;\n}\n\n.floating-chat-container {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  .chat-icon {\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    background-color: #ff4d4f;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    color: #fff;\n    position: relative;\n    box-shadow: 0 0 15px rgba(255, 77, 79, 0.5);\n\n    &::before,\n    &::after {\n      content: '';\n      position: absolute;\n      inset: -3px;\n      border-radius: 50%;\n      border: 2px solid #ff4d4f;\n      filter: drop-shadow(0 0 8px rgba(255, 77, 79, 0.8));\n      animation: neonPulse 2s ease-in-out infinite;\n    }\n\n    &::after {\n      animation-delay: 1s;\n      filter: drop-shadow(0 0 12px rgba(255, 77, 79, 0.6));\n    }\n  }\n\n  @keyframes neonPulse {\n    0% {\n      transform: scale(1);\n      opacity: 0.8;\n      filter: drop-shadow(0 0 8px rgba(255, 77, 79, 0.8));\n    }\n    50% {\n      transform: scale(1.4);\n      opacity: 0;\n      filter: drop-shadow(0 0 15px rgba(255, 77, 79, 1));\n    }\n    100% {\n      transform: scale(1.6);\n      opacity: 0;\n      filter: drop-shadow(0 0 8px rgba(255, 77, 79, 0.8));\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
